const E = {
  "image/jpeg": "JPEG Image",
  "image/png": "PNG Image",
  "image/gif": "GIF Image",
  "image/webp": "WebP Image",
  "application/pdf": "PDF Document",
  "text/plain": "Plain Text",
  "text/markdown": "Markdown Document",
  "text/csv": "CSV File"
}, p = {
  MIN_SIZE: 1,
  // 1 byte
  MAX_SIZE: 10 * 1024 * 1024,
  // 10 MB
  IMAGE_MAX_SIZE: 5 * 1024 * 1024
  // 5 MB — Anthropic's limit for image attachments
}, c = {
  ".md": "text/markdown",
  ".pdf": "application/pdf",
  ".txt": "text/plain",
  ".csv": "text/csv"
}, _ = /* @__PURE__ */ new Set(["application/vnd.ms-excel"]);
function u(e) {
  const a = e.name.includes(".") ? e.name.slice(e.name.lastIndexOf(".")).toLowerCase() : "";
  return (e.type === "" || e.type === "application/octet-stream" || _.has(e.type)) && a && a in c ? c[a] : e.type;
}
function g(e) {
  if (e.size < p.MIN_SIZE)
    return "FILE_TOO_SMALL";
  const a = u(e);
  if (!(a in E))
    return "UNSUPPORTED_TYPE";
  if (a.startsWith("image/")) {
    if (e.size > p.IMAGE_MAX_SIZE)
      return "IMAGE_TOO_LARGE";
  } else if (e.size > p.MAX_SIZE)
    return "FILE_TOO_LARGE";
  return null;
}
function f(e, a) {
  return a.some(
    (n) => n.name === e.name && n.size === e.size && n.file.lastModified === e.lastModified
  );
}
async function I(e, a, n) {
  const i = new FormData();
  return Object.entries(a.signature.fields).forEach(([r, s]) => {
    i.append(r, s);
  }), i.append("file", e), new Promise((r, s) => {
    const t = new XMLHttpRequest();
    n && t.upload.addEventListener("progress", (o) => {
      if (o.lengthComputable) {
        const l = o.loaded / o.total * 100;
        n(l);
      }
    }), t.addEventListener("load", () => {
      if (t.status >= 200 && t.status < 300) {
        const o = a.signature.fields.key, l = a.signature.url.endsWith("/") ? a.signature.url.slice(0, -1) : a.signature.url, d = o.startsWith("/") ? o : `/${o}`, m = `${l}${d}`;
        r(m);
      } else
        s(new Error(`Upload failed with status ${t.status}: ${t.responseText}`));
    }), t.addEventListener("error", () => {
      s(new Error("Network error during upload"));
    }), t.addEventListener("abort", () => {
      s(new Error("Upload was aborted"));
    }), t.open("POST", a.signature.url), t.send(i);
  });
}
function M(e, a) {
  const n = [], i = [], r = [], s = e.__uploadFiles.get();
  return a.forEach((t) => {
    if (f(t, s)) {
      r.push({ name: t.name, reason: "File already selected" });
      return;
    }
    const o = g(t);
    if (o) {
      let d = "";
      switch (o) {
        case "UNSUPPORTED_TYPE":
          d = `File type ${u(t) || t.type || "unknown"} is not supported`;
          break;
        case "IMAGE_TOO_LARGE":
          d = `Image is too large (max ${p.IMAGE_MAX_SIZE / 1024 / 1024}MB)`;
          break;
        case "FILE_TOO_LARGE":
          d = `File is too large (max ${p.MAX_SIZE / 1024 / 1024}MB)`;
          break;
        case "FILE_TOO_SMALL":
          d = "File is too small";
          break;
        case "FILE_CORRUPTED":
          d = "File appears to be corrupted";
          break;
      }
      i.push({ name: t.name, error: d });
      return;
    }
    const l = {
      id: crypto.randomUUID(),
      file: t,
      mimeType: u(t),
      size: t.size,
      name: t.name,
      status: "pending"
    };
    n.push(l);
  }), n.length > 0 && e.addUploadFiles(n), {
    addedCount: n.length,
    errors: i,
    skipped: r
  };
}
async function F(e, a) {
  if (e.id == null)
    await e.waitUntilReady();
  else if (e.isEnding || e.isEnded || e.status === "error")
    throw new Error("Cannot upload file: session has ended");
  const i = e.__uploadFiles.get().find((r) => r.id === a);
  if (!i)
    throw new Error(`File with ID ${a} not found`);
  try {
    e.updateUploadFile(a, { status: "uploading", uploadProgress: 0 });
    const r = await e.getUploadSignature({
      size: i.size.toString(),
      mime_type: i.mimeType
    }), s = await I(i.file, r, (t) => {
      e.updateUploadFile(a, { uploadProgress: t });
    });
    return e.updateUploadFile(a, { status: "uploaded", uploadedUrl: s, uploadProgress: 100 }), s;
  } catch (r) {
    const s = r instanceof Error ? r.message : "Upload failed";
    throw e.updateUploadFile(a, { status: "error", error: s }), r;
  }
}
async function h(e) {
  const n = e.__uploadFiles.get().filter((t) => t.status === "pending");
  if (n.length === 0)
    return { successful: [], failed: [] };
  const i = await Promise.allSettled(
    n.map(async (t) => {
      try {
        const o = await F(e, t.id);
        return {
          id: t.id,
          name: t.name,
          mimeType: t.mimeType,
          uploadedUrl: o
        };
      } catch (o) {
        throw console.error(`Failed to upload file ${t.name}:`, o), o;
      }
    })
  ), r = [], s = [];
  return i.forEach((t, o) => {
    const l = n[o];
    if (t.status === "fulfilled")
      r.push(t.value);
    else {
      const d = t.reason instanceof Error ? t.reason.message : "Upload failed";
      s.push({
        id: l.id,
        name: l.name,
        error: d
      }), e.removeUploadFile(l.id);
    }
  }), { successful: r, failed: s };
}
export {
  p as FILE_SIZE_LIMITS,
  E as SUPPORTED_FILE_TYPES,
  M as addCopilotFiles,
  f as fileAlreadyExists,
  u as resolveFileMimeType,
  h as uploadAllCopilotFiles,
  F as uploadCopilotFile,
  I as uploadToGCS,
  g as validateFile
};
